import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../utils/helpers/model.helper';
import { GlobalSearchResults } from './sub-models/global-search-results.model';

export const DOCUMENTS_SEARCH_SCHEMA = Object.freeze({
  INVOICES: GlobalSearchResults,
  ESTIMATES: GlobalSearchResults,
  CREDIT_MEMOS: GlobalSearchResults,
  PURCHASE_ORDERS: GlobalSearchResults,
});
const RECORD = generateSchema(DOCUMENTS_SEARCH_SCHEMA);
const KEYS: any = generateKeys(DOCUMENTS_SEARCH_SCHEMA);

export class DocumentsSearch extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.INVOICES,
        value: new GlobalSearchResults(this.invoices),
      },
      {
        key: KEYS.ESTIMATES,
        value: new GlobalSearchResults(this.estimates),
      },
      {
        key: KEYS.CREDIT_MEMOS,
        value: new GlobalSearchResults(this.creditMemos),
      },
      {
        key: KEYS.PURCHASE_ORDERS,
        value: new GlobalSearchResults(this.purchaseOrders),
      },
    ]);

    return selfModel as DocumentsSearch;
  }

  get invoices(): GlobalSearchResults {
    return this.get(KEYS.INVOICES);
  }

  get estimates(): GlobalSearchResults {
    return this.get(KEYS.ESTIMATES);
  }

  get creditMemos(): GlobalSearchResults {
    return this.get(KEYS.CREDIT_MEMOS);
  }

  get purchaseOrders(): GlobalSearchResults {
    return this.get(KEYS.PURCHASE_ORDERS);
  }

  hasAnyResults(): boolean {
    return this.totalNumberOfResults() > 0;
  }

  totalNumberOfResults(): number {
    return (
      this.invoices.totalMatches +
      this.estimates.totalMatches +
      this.creditMemos.totalMatches +
      this.purchaseOrders.totalMatches
    );
  }
}
